import { MediaType } from '~client/model/media-type';

/**
 * Returns accepted file formats for the input depending on media type
 * @param mediaType
 */
export const getAcceptedFileFormats = (mediaType: MediaType): string => {
  switch (mediaType) {
    case MediaType.IMAGE:
      return 'image/*';
    case MediaType.VIDEO:
      return 'video/*';
    default:
      throw Error(`Upload is not supported for ${mediaType}.`);
  }
};

/**
 * Returns whether file upload should be enabled/disabled depending on media type
 * @param mediaType
 */
export const enableFileUpload = (mediaType: MediaType): boolean => {
  switch (mediaType) {
    case MediaType.IMAGE:
    case MediaType.VIDEO:
      return true;
    default:
      return false;
  }
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-overlay/helper/media-upload.helper.ts